<template>
    <component :is="currentComponent" />
</template>

<script>
    import _ from 'lodash';
    import CategoryStart from '@/components/CategoryStart.vue';
    import CategoryStep from '@/components/CategoryStep.vue';
    import CategoryFinish from '@/components/CategoryFinish.vue';

    export default {
        name: 'Category',
        components: {
            CategoryStart,
            CategoryStep,
            CategoryFinish
        },
        computed: {
            alias () {
                return this.$route.params.alias;
            },
            categories () {
                return this.$store.state.categories.all;
            },
            currentComponent () {
                if (this.$store.getters.isStepsNew) {
                    return CategoryStart;
                } else if (this.$store.getters.isStepsDone) {
                    return CategoryFinish;
                } else {
                    return CategoryStep;
                }
            }
        },
        created () {
            this.$store.dispatch('getCategories').then(() => {
                let categoryId = _.find(this.categories, { alias: this.alias }).id;
                this.$store.dispatch('setCategoryId', categoryId);
                this.$store.dispatch('getMessagesByCategoryId', categoryId);
            });
        }
    }
</script>
